<template>
  <div id="service">
    <h1 class="page-title">{{service.title}}</h1>
    <div id="service-info">
      <div id="description">
        <div v-html="service.description"></div>
        <router-link to="/contacts">Vamos bater um papo?</router-link>
      </div>
      <img id="service-img" :src="service.imgUrl" :alt="service.imgAlt" />
    </div>
    <div id="other-services">
      <h2>Outros serviços</h2>
      <ServiceList :servicesArray="otherServices" />
    </div>
  </div>
</template>

<script>
import ServiceList from "@/components/ServiceList";
export default {
  components: {
    ServiceList
  },
  data() {
    return {
      // service: []
    };
  },
  watch: {
    async $route(to, from) {
      await this.$store.dispatch("fetchService", this.$route.params.slug);
      // await this.$store.dispatch("FETCH_SERVICES");
      document.title = "exception jr - " + this.service.title;
      // next();
    }
  },
  computed: {
    service() {
      return this.$store.state.service;
    },
    otherServices() {
      return this.$store.state.services.filter(service => {
        return service.title !== this.service.title;
      });
    }
  },
  async created() {
    await this.$store.dispatch("fetchService", this.$route.params.slug);
    await this.$store.dispatch("FETCH_SERVICES");
    document.title = "exception jr - " + this.service.title;
  }
};
</script>

<style scoped lang="scss" >
#service {
}
h1 {
  &::after {
    margin-top: 5px;
    content: "";
    display: block;
    height: 10px;
    width: 40%;
    background: $verde-exception;
    @include for-tablet-portraid-up {
      width: 20%;
    }
  }
}
#service-info {
  display: grid;
  @include for-tablet-portraid-up {
    grid-template-columns: 1fr 1fr;
  }
  // grid-template-rows: 1fr 1fr;
  #description {
    padding-top: 30px;
    grid-row: 2;
    @include for-tablet-portraid-up {
      grid-row: 1;
      grid-column: 1;
    }
  }
  a {
    @include reset-css;
    text-decoration: none;
    @include flexbox(row, center, center);
    background: $verde-exception;
    border-radius: 10px;
    // font-size: 1.5rem;
    color: #fff;
    font-weight: 600;
    // margin: 30px 30px;

    margin: 30px 0;
    transition: all 0.2s;
    padding: 15px;
    @include for-tablet-portraid-up {
      width: 50%;
    }

    &:hover {
      transform: scale(1.05);
    }
  }
}
#other-services {
  h2 {
    font-size: 3rem;
    color: $verde-exception;
  }
  #services-container {
    justify-content: space-around;
  }
}
</style>